// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/bank_switch/firstparty/v1/list_movable_payments.proto

/* oxlint-disable */
import { ApiMovablePayment } from "./movable_payment";

/** Request to list the movable payments detected for the current user. */
export interface ApiListMovablePaymentsRequest {
}

/** Response containing the movable payments detected for the current user. */
export interface ApiListMovablePaymentsResponse {
  /** The movable payments detected for the current user. */
  readonly movablePayments: readonly ApiMovablePayment[];
}

export const ApiListMovablePaymentsRequest: MessageFns<ApiListMovablePaymentsRequest> = {
  fromJSON(_: any): ApiListMovablePaymentsRequest {
    return {};
  },

  toJSON(_: ApiListMovablePaymentsRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiListMovablePaymentsResponse: MessageFns<ApiListMovablePaymentsResponse> = {
  fromJSON(object: any): ApiListMovablePaymentsResponse {
    return {
      movablePayments: globalThis.Array.isArray(object?.movable_payments)
        ? object.movable_payments.map((e: any) => ApiMovablePayment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiListMovablePaymentsResponse): unknown {
    const obj: any = {};
    if (message.movablePayments?.length) {
      obj.movable_payments = message.movablePayments.map((e) => ApiMovablePayment.toJSON(e));
    }
    return obj;
  },
};

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
